import React from 'react';

function Flag() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M19.6 4.704L10 0v21.6H7.6v-2.076C5.452 19.944 4 20.712 4 21.6c0 1.32 3.228 2.4 7.2 2.4s7.2-1.08 7.2-2.4c0-1.188-2.592-2.172-6-2.364V8.376l7.2-3.672z" />
    </svg>
  );
  /* eslint-enable */
}

export default Flag;



// WEBPACK FOOTER //
// ./src/common/icons/Flag.js